// TYPE ELITE — Map every font direction to a real Google Font for preview tiles.
export const FONT_MAP = {
  // Sans Serif
  'Geometric': { css: '"Poppins", sans-serif', weight: 700 },
  'Grotesque': { css: '"Space Grotesk", sans-serif', weight: 700 },
  'Neo-Grotesque': { css: '"Manrope", sans-serif', weight: 800 },
  'Humanist': { css: '"Nunito Sans", sans-serif', weight: 800 },
  'Condensed': { css: '"Barlow Condensed", sans-serif', weight: 800 },
  'Extended': { css: '"Big Shoulders Display", sans-serif', weight: 800 },
  'Rounded': { css: '"Fredoka", sans-serif', weight: 700 },
  'Techno': { css: '"Orbitron", sans-serif', weight: 800 },
  'Athletic / Block': { css: '"Bebas Neue", sans-serif', weight: 400 },
  // Serif
  'Old-Style': { css: '"EB Garamond", serif', weight: 700 },
  'Transitional': { css: '"Cormorant Garamond", serif', weight: 700 },
  'Didone / High-Contrast': { css: '"Playfair Display", serif', weight: 900 },
  'Slab Serif': { css: '"Roboto Slab", serif', weight: 800 },
  'Wedge Serif': { css: '"Zilla Slab", serif', weight: 700 },
  'Decorative Display Serif': { css: '"DM Serif Display", serif', weight: 400 },
  // Script
  'Formal Calligraphy': { css: '"Great Vibes", cursive', weight: 400 },
  'Brush Script': { css: '"Sacramento", cursive', weight: 400 },
  'Signature': { css: '"Homemade Apple", cursive', weight: 400 },
  'Monoline': { css: '"Dancing Script", cursive', weight: 700 },
  'Retro Sign-Painter': { css: '"Lobster", cursive', weight: 400 },
  'Bold Connected Script': { css: '"Pacifico", cursive', weight: 400 },
  // Display
  'Bubble': { css: '"Bungee", display', weight: 400 },
  'Chunky': { css: '"Ultra", serif', weight: 400 },
  'Psychedelic': { css: '"Rubik Puddles", display', weight: 400 },
  'Y2K': { css: '"Rubik Mono One", sans-serif', weight: 400 },
  'Western': { css: '"Rye", display', weight: 400 },
  'Varsity / Collegiate': { css: '"Bungee Inline", display', weight: 400 },
  'Tattoo': { css: '"Nosifer", display', weight: 400 },
  'Circus / Carnival': { css: '"Ewert", display', weight: 400 },
  'Graffiti': { css: '"Permanent Marker", cursive', weight: 400 },
  'Comic': { css: '"Bangers", display', weight: 400 },
  'Stencil': { css: '"Stardos Stencil", display', weight: 700 },
  'Ransom / Cutout': { css: '"Rubik Wet Paint", display', weight: 400 },
  // Gothic
  'Blackletter': { css: '"UnifrakturCook", display', weight: 700 },
  'Old English': { css: '"UnifrakturMaguntia", display', weight: 400 },
  'Fraktur': { css: '"Pirata One", display', weight: 400 },
  'Uncial': { css: '"MedievalSharp", display', weight: 400 },
  'Medieval Inscription': { css: '"Cinzel", serif', weight: 900 },
  // Handwritten
  'Marker': { css: '"Permanent Marker", cursive', weight: 400 },
  'Chalk': { css: '"Caveat", cursive', weight: 700 },
  'Crayon': { css: '"Gochi Hand", cursive', weight: 400 },
  'Doodle': { css: '"Shadows Into Light", cursive', weight: 400 },
  'Casual Print': { css: '"Kalam", cursive', weight: 700 },
  // Horror
  'Dripping': { css: '"Creepster", display', weight: 400 },
  'Slasher / Scratched': { css: '"Butcherman", display', weight: 400 },
  'Monster Chunky': { css: '"Nosifer", display', weight: 400 },
  'Cemetery Slab': { css: '"Special Elite", monospace', weight: 400 },
  'Witchy Script': { css: '"Pirata One", display', weight: 400 },
  'Creepy Carnival': { css: '"Ewert", display', weight: 400 },
  'Distressed Warning': { css: '"Faster One", display', weight: 400 },
  'Retro Horror Poster': { css: '"Metal Mania", display', weight: 400 },
  'Cute Spooky': { css: '"Fredoka", sans-serif', weight: 700 },
};

export const GOOGLE_FONT_URL = 'https://fonts.googleapis.com/css2?' + [
  'family=Poppins:wght@700',
  'family=Space+Grotesk:wght@700',
  'family=Manrope:wght@800',
  'family=Nunito+Sans:wght@800',
  'family=Barlow+Condensed:wght@800',
  'family=Big+Shoulders+Display:wght@800',
  'family=Fredoka:wght@700',
  'family=Orbitron:wght@800',
  'family=Bebas+Neue',
  'family=EB+Garamond:wght@700',
  'family=Playfair+Display:wght@900',
  'family=Roboto+Slab:wght@800',
  'family=Zilla+Slab:wght@700',
  'family=DM+Serif+Display',
  'family=Great+Vibes',
  'family=Sacramento',
  'family=Homemade+Apple',
  'family=Dancing+Script:wght@700',
  'family=Lobster',
  'family=Pacifico',
  'family=Bungee',
  'family=Ultra',
  'family=Rubik+Puddles',
  'family=Rubik+Mono+One',
  'family=Rye',
  'family=Bungee+Inline',
  'family=Nosifer',
  'family=Ewert',
  'family=Permanent+Marker',
  'family=Bangers',
  'family=Stardos+Stencil:wght@700',
  'family=Rubik+Wet+Paint',
  'family=UnifrakturCook:wght@700',
  'family=UnifrakturMaguntia',
  'family=Pirata+One',
  'family=MedievalSharp',
  'family=Cinzel:wght@900',
  'family=Caveat:wght@700',
  'family=Gochi+Hand',
  'family=Shadows+Into+Light',
  'family=Kalam:wght@700',
  'family=Creepster',
  'family=Butcherman',
  'family=Special+Elite',
  'family=Faster+One',
  'family=Metal+Mania',
].join('&') + '&display=swap';
